import Sidebar from "./Sidebar";
import Header from "./Header";
import { useAuth } from "../../contexts/AuthContext";
import { useRole } from "../../contexts/RoleContext";
import Skeleton from "../ui/Skeleton";
import { useNavigate } from "react-router-dom";

function MainLayout({ children }) {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => {
    logout();
    navigate("/login");
  };
  const { role, loading } = useRole();

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      {loading ? (
        <Skeleton.Loader />
      ) : (
        <>
          <Sidebar onLogout={handleLogout} role={role} />
          <div className="flex-1 flex flex-col overflow-hidden">
            <Header />
            <main className="flex-1 overflow-y-auto p-6">{children}</main>
          </div>
        </>
      )}
    </div>
  );
}

export default MainLayout;
